import ResumePreviewModal from "./ResumePreviewModal";

export default ResumePreviewModal;
